import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import SalaryDetailsAndEdit from '@/components/common/SalaryDetailsAndEdit';
import SalaryFields from '@/components/common/SalaryFields';
import ViewDocumentModal from '@/components/common/ViewDocumentModal';
import Button from '@/components/ui/Button';
import {
  IAddEmployeeForm,
  IsalaryDetail,
  ISalaryPageStates,
} from '@/interfaces/employee.model';
import {
  ISalaryHeadConfig,
  ISalaryHeadDetailResponse,
} from '@/interfaces/salary.model';
import { IDocument, IUser } from '@/interfaces/user.model';
import { showToastNotification } from '@/utility/helper';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
interface IEmployeeSalaryDetailStep9Props {
  pageStates: ISalaryPageStates;
  empId: string | null;
  setPageStates: React.Dispatch<React.SetStateAction<ISalaryPageStates>>;
  getEmployeeDetail: () => Promise<void>;
  activeTab: number;
  employeeDetail: IUser | null;
}
const EmployeeSalaryDetailStep9 = ({
  pageStates,
  empId,
  setPageStates,
  getEmployeeDetail,
  activeTab,
  employeeDetail,
}: IEmployeeSalaryDetailStep9Props) => {
  const [isDocumentOpen, setIsDocumentOpen] = useState<boolean>(false);
  const [selectedDocument, setSelectedDocument] =
    useState<Partial<IDocument> | null>(null);

  const [salaryDetail, setSalaryDetail] = useState<IsalaryDetail>({
    isBaseData: [],
    earning: [],
    fromEmployer: [],
    deduction: [],
    basicSalary: 0,
    netSalary: 0,
    dailyWages: 0,
    sumOfFromEmployer: 0,
    siteSalaryHeadDetail: [],
  });
  const { getValues } = useFormContext<IAddEmployeeForm>();
  useEffect(() => {
    if (activeTab == 9) {
      if (!pageStates.isSalaryCreated) {
        getSalaryDetail();
      } else if (empId) {
        getUserSalary();
      }
    }
  }, [pageStates?.isSalaryCreated, activeTab]);
  const toggleModal = () => {
    setIsDocumentOpen(!isDocumentOpen);
  };

  const getSalaryDetail = async () => {
    try {
      const data = getValues();
      if (data?.officeId === undefined || data?.officeId == '') return;

      const response: ISalaryHeadDetailResponse = await callApi(
        `${API_URL + API_ENDPOINT.getSiteSalaryHeadDetail}?siteId=${data.officeId}&from=userSalary`,
        { method: 'GET' },
      );

      if (response?.status) {
        setSalaryDetail((prev) => ({
          ...prev,
          siteSalaryHeadDetail: response.data,
        }));
      } else {
        console.error('Failed to fetch salary detail:', response?.message);
      }
    } catch (error: unknown) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  };

  const getUserSalary = async () => {
    setPageStates((prev) => ({
      ...prev,
      isLoadingGetUserSalary: true,
    }));
    try {
      const res: ISalaryHeadDetailResponse = await callApi(
        API_URL + API_ENDPOINT.getUserSalary + `?userId=${empId}`,
        {
          method: 'GET',
        },
      );
      if (res?.status) {
        const isBase: ISalaryHeadConfig[] = [];
        const earning: ISalaryHeadConfig[] = [];
        const fromEmployer: ISalaryHeadConfig[] = [];
        const deduction: ISalaryHeadConfig[] = [];
        let basicSalary = 0;
        let netSalary = 0;
        let dailyWages = 0;
        let sumOfFromEmployer = 0;

        for (const item of res.data) {
          const head = item?.sitesalaryhead?.salaryhead;
          if (!head) continue;

          if (head.fromEmployeer) {
            sumOfFromEmployer += Number(item?.amount);
          }

          if (head.isBase && head.name !== 'Other Allowances') {
            isBase.push(item);

            if (head.name === 'Basic Salary')
              basicSalary = Number(item?.amount ?? 0);
            if (head.name === 'Net Salary')
              netSalary = Number(item?.amount ?? 0);
            if (head.name === 'Daily Wages')
              dailyWages = Number(item?.amount ?? 0);

            continue;
          }
          if (head.type === 'earning') {
            if (head?.fromEmployeer) {
              fromEmployer.push(item);
            } else {
              earning.push(item);
            }
          } else {
            deduction.push(item);
          }
        }
        setSalaryDetail((prev) => ({
          ...prev,
          earning,
          fromEmployer,
          deduction,
          isBaseData: isBase,
          basicSalary,
          netSalary,
          dailyWages,
          sumOfFromEmployer,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((prev) => ({
        ...prev,
        isLoadingGetUserSalary: false,
      }));
    }
  };
  return (
    <>
      {!pageStates?.isSalaryCreated &&
      employeeDetail?.designation?.name == 'Trainee' ? (
        <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-3">
          <div className="d-flex align-items-center justify-content-center gap-3">
            <Button
              isLoading={pageStates.isLoadingOfferLetter}
              type="button"
              className="btn btn-primary px-5"
              // onClick={handleGenerateOfferLetter}
            >
              Generate Training Letter
            </Button>
          </div>
        </div>
      ) : !pageStates?.isSalaryCreated ? (
        <SalaryFields
          salary={salaryDetail}
          empId={empId}
          getEmployeeDetail={getEmployeeDetail}
          setPageStates={setPageStates}
          isLoadingSalaryCreation={pageStates?.isLoadingSalaryCreation}
        />
      ) : (
        ''
      )}
      {pageStates?.isSalaryCreated && (
        <SalaryDetailsAndEdit
          salaryDetail={salaryDetail}
          toggleModal={toggleModal}
          setSelectedDocument={setSelectedDocument}
          setPageStates={setPageStates}
          empId={empId}
          getEmployeeDetail={getEmployeeDetail}
          pageStates={pageStates}
        />
      )}
      <ViewDocumentModal
        isOpen={isDocumentOpen}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
};
export default EmployeeSalaryDetailStep9;
